import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";

import styles from "./Promotion.module.scss";

export interface PromotionProps {
  code: string;
  imageUrl: string;
  onClick: () => void;
  isActive: boolean;
}

export const Promotion: FC<PromotionProps> = ({ code, imageUrl, onClick, isActive }) => {
  const { __ } = useTranslations();

  return (
    <button
      type="button"
      className={classNames(styles.promotionButton, { [styles.isActive]: isActive })}
      onClick={onClick}
      aria-label={`${__("libs.ui.promotion.button_aria_label")} ${code}`}
    >
      <div className={styles.imageWrapper}>
        <ImageBehaviour src={imageUrl} alt={code} className={styles.image} />
      </div>
    </button>
  );
};
